import React, { Component } from "react";
import "./Timeline.scss";
import { vPush } from "../../Services/Analytics";

export default class Timeline extends Component {
    constructor(props) {
        super();
        this.renderBars = this.renderBars.bind(this);
        this.ClickNavBar = this.ClickNavBar.bind(this);
        this.state = {
            CurrentBar: 0,
            Selected: {}
        }
    }
    componentDidMount() {
        // let i = 0;
        // this.props.Categories.forEach(obj => {
        //     if (i == 0) {
        //         vPush(`${obj[0].Category}`, `${window.location.pathname}Category-0`);
        //     }
            // i++;
        // });
    }
    componentWillReceiveProps(newProps) {
        if (newProps.CurrentSlide != this.state.CurrentBar) {
            let i = 0;
            newProps.Categories.forEach(obj => {
                if (newProps.CurrentSlide == i) {
                    vPush(`${obj[0].Category}`, `${window.location.pathname}Category-${newProps.CurrentSlide}`);
                }
                i++;
            });
            this.setState({
                CurrentBar: newProps.CurrentSlide
            })
        }
        this.setState({
            Selected: newProps.Selected,
            isEndScreen: newProps.showEndScreen
        })
    }
    renderBars() {
        let navbar = [];
        for (let i = 0; i < this.props.CategoryLength; i++) {
            navbar.push(<InnerBar key={i}
                current={i == this.state.CurrentBar}
                isActive={this.state.Selected[i] != null}
                onClick={() => this.ClickNavBar(i)}
            />);
        }
        return navbar;
    }
    ClickNavBar(index) {
        this.setState({
            CurrentBar: index
        }, () => {
            this.props.OwlRef.to(index, this.state.isEndScreen ? 0 : 600);
        })
    }
    render() {
        return (
            <nav>
                <div className="nav-container">
                    {this.renderBars()}
                </div>
            </nav>
        )
    }
}


const InnerBar = props => {
    return (
        <div className={`navbar${props.current ? " current" : ""}${props.isActive ? " active" : ""}`} onClick={props.onClick}></div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Common/Timeline/Timeline.jsx